import React , { useState, useEffect }  from "react";
import "./styles/App.css";
import { SignInSide } from "./screens/SignInSide";
import { Hub } from "./screens/Hub";
import { Home } from "./screens/Home";
import { HomeFS } from "./screens/HomeFS";

import { Home2 } from "./screens/Home2";
import { HomeTest } from "./screens/HomeTest";
import { Help } from "./screens/Help";
import { BugReport } from "./screens/BugReport";
import { Collaborator } from "./screens/Collaborator";

import { DatasetBuilderSentences } from "./screens/DatasetBuilderSentences";
import { DatasetBuilder } from "./screens/DatasetBuilder2";

import { FavoriteSigns } from "./screens/Favorites";
import { DonateSign } from "./screens/DonateSign";
import { DonateFS } from "./screens/DonateFS";

import { DonateSentence } from "./screens/DonateSentence";
import { DonateResponse } from "./screens/DonateResponse";
import { InterfaceDonateSentence } from "./screens/InterfaceDonateSentence"


import { VersusMachine } from "./screens/VersusMachine";
import { VersusMachine2 } from "./screens/VersusMachine2";
import { MoveYourSkeleton } from "./screens/MoveYourSkeleton";
import { SignsDB } from "./screens/SignsDB";
import { SignsDB2 } from "./screens/SignsDB2";

import { Recorder } from "./screens/Recorder";
import { Switch, BrowserRouter } from "react-router-dom";
import { PublicRoute, PrivateRoute } from "./api/WebRoutes";
import { VideoProvider } from "./api/VideoProvider";
import { CustomThemeProvider } from "./api/ThemeProvider";
// import { Mediapipe } from './api/MediapipeHandsPose';
import { Mediapipe } from './api/MediapipeHolistic';
import { MediapipeHandsPoseDonate } from './api/MediapipeHandsPoseDonate';

import { VirtualBG } from './api/VirtualBG';
//import { redirectToGooglePlay } from './api/utils/device'
import { History } from "./screens/History";
import { RecordsRegister } from "./screens/RecordsRegister";
import { SnackbarProvider } from "notistack";
import { StyledEngineProvider } from "@mui/material/styles";
import { StylesProvider } from "@material-ui/core/styles";
import { DataProvider } from "./api/DataProvider";
import { CommProvider } from "./api/CommProvider";
import { TourProvider } from '@reactour/tour';
import { TimerProvider } from "./api/TimerProvider";
import { VideoSyncMonitor } from "./api/VideoSyncMonitor";
import { stepsSearchLSE, tourStyles } from "./components/tour/TourConfig";
import { Reports } from "./screens/Reports";
import { Teams } from "./screens/Teams";
import { RecorderTask } from "./screens/RecorderTask";
import { Submission } from "./screens/Submission";
import { Leaderboard } from "./screens/Leaderboard";
import { LeaderboardSentence } from "./screens/LeaderboardSentence";
import { SentencesDB } from "./screens/SentencesDB"
import { SearchByVideo } from "./screens/SearchByVideo";
import { StreamProvider } from "./api/StreamProvider";
import { SegmenterProvider } from "./api/SegmenterProvider";
import { PoserProvider } from "./api/PoserProvider";
import { HandsProvider } from "./api/HandsProvider";
import { MediapipeHolisticProvider } from './api/MediapipeHolisticProvider';

import { Survey } from "./screens/Survey"

function App() {
  /* If the device is a phone go to Google Play */
  /*
  // MOB - MOBILE REDIRECTION DEACTIVATED 
  useEffect(() => {
    redirectToGooglePlay();
  }, [])
  */
  const customBadge = ({ totalSteps, currentStep }) => currentStep + 1 + "/" + totalSteps;

  /* 
  WRAPPERS
  * StyledEngineProvider: control css injection order for MUI v5 components
  * StylesProvider: control css injection order for MUI v4 components
  * ThemeProvider: light/dark theme provider
  * BrowserRouter: different app routes
  * AuthProvider: firebase auth
  * Video Provider: recording api
  * Tour Provider: guided interactions / app showcase
  * Sign Provider: url_vid signs & definitions
  */
  return (
    <StyledEngineProvider injectFirst>
      <StylesProvider injectFirst>
        <CustomThemeProvider>
          <SnackbarProvider maxSnack={2} autoHideDuration={2000}>
            <BrowserRouter>
              <TimerProvider>
                <VideoSyncMonitor>
                  <MediapipeHolisticProvider>
                    <PoserProvider>
                    <HandsProvider>
                    <SegmenterProvider>
                      <StreamProvider>
                        <MediapipeHandsPoseDonate>
                        <Mediapipe>
                          <VirtualBG>
                            <CommProvider>
                              <DataProvider>
                                <VideoProvider>
                                  <TourProvider styles={tourStyles} steps={stepsSearchLSE} badgeContent={customBadge} onClickHighlighted={(e) => { e.stopPropagation(); }} disableInteraction scrollSmooth>
                                    <Switch>
                                      <PublicRoute path="/sign" component={SignInSide} restricted={true}/>
                                      {/* <PrivateRoute exact path="/" component={Hub} /> */}

                                      <PrivateRoute exact path="/camera" component={Home} />
                                      <PrivateRoute exact path="/cameraFS" component={HomeFS} />
                                      <PrivateRoute exact path="/cameraTest" component={HomeTest} />

                                      <PrivateRoute exact path="/search" component={SignsDB} />
                                      
                                      <PrivateRoute exact path="/sentences" component={SentencesDB} />
                                      <PrivateRoute exact path="/recorder" component={Recorder} />
                                      <PrivateRoute exact path="/history" component={History} />
                                      <PrivateRoute exact path="/favs" component={FavoriteSigns} />
                                      <PrivateRoute exact path="/help" component={Help} />
                                      <PrivateRoute exact path="/collaborator" component={Collaborator} />


                                      <PrivateRoute exact path="/datasetbuilder" component={DatasetBuilder} />
                                      <PrivateRoute exact path="/datasetbuilderSentence" component={DatasetBuilderSentences} />

                                      <PrivateRoute exact path="/bug" component={BugReport} />
                                      <PrivateRoute exact path="/recordsRegister" component={RecordsRegister} />

                                      <PrivateRoute exact path="/donateSign" component={DonateSign}/>
                                      <PrivateRoute exact path="/donateFS" component={DonateFS}/>

                                      <PrivateRoute exact path="/donateSentence" component={DonateSentence}/>
                                      <PrivateRoute exact path="/donateResponse" component={DonateResponse}/>

                                      <PrivateRoute exact path="/interfaceResponse" component={InterfaceDonateSentence}/>   

                                      <PrivateRoute exact path="/versusMachine" component={VersusMachine} />
                                      <PrivateRoute exact path="/versusMachine2" component={VersusMachine2} />
                                      <PrivateRoute exact path="/moveYourSkeleton" component={MoveYourSkeleton} />
                                      <PrivateRoute exact path="/reports" component={Reports} />
                                      <PrivateRoute exact path="/teams" component={Teams} />
                                      <PrivateRoute exact path="/recorderTask" component={RecorderTask} />
                                      <PrivateRoute exact path="/submission" component={Submission} />
                                      <PrivateRoute exact path="/leaderboard" component={Leaderboard} />
                                      <PrivateRoute exact path="/leaderboardSentence" component={LeaderboardSentence} />

                                      <PrivateRoute exact path="/survey" component={Survey} />

                                      <PrivateRoute component={Hub}/>
                                      {/* <PrivateRoute component={Hub} /> */}
                                    </Switch>
                                  </TourProvider>
                                </VideoProvider>
                              </DataProvider>
                            </CommProvider>
                          </VirtualBG>
                        </Mediapipe>
                        </MediapipeHandsPoseDonate>
                      </StreamProvider>
                    </SegmenterProvider>
                    </HandsProvider>
                    </PoserProvider>
                  </MediapipeHolisticProvider>
                </VideoSyncMonitor>
              </TimerProvider>
            </BrowserRouter>
          </SnackbarProvider>
        </CustomThemeProvider>
      </StylesProvider>
    </StyledEngineProvider>
  );
}

export default App;

// firebase deploy --only hosting
// firebase hosting:channel:deploy beta_upload --expires 30d
